import React from 'react';
import { Link } from 'react-router-dom';

function Banner(props) {
    const { item, responsive } = props;

    return (
        <div className="project-box-style2" data-aos="fade-up" data-aos-delay="100" data-aos-duration="800">
            <div className="image">
                <img src={item.img} alt="" />
            </div>
            <div className="content">
                <h5 style={{
                    height: responsive ? '40px' : '40px',
                    fontSize: responsive ? '14px' : 'inherit', // Tamaño de letra reducido si es responsive
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center'
                }}>
                    {item.title}
                </h5>
                <p className="desc" style={{
                    height: responsive ? '80px' : 'inherit',
                    textAlign: 'center'
                }}>
                    {item.desc}
                </p>
                <p className="number">{item.number}</p>
            </div>
            <Link to="#" className="btn_project">
                <span><i className="far fa-angle-right"></i></span>
            </Link>
            {/* <hr style={{ height: '1px', backgroundColor: 'black', border: 'none' }} /> */}
        </div>
    );
}

export default Banner;